import { ContactStatus, IContactItem } from "interfaces";
import { TooltipParagraph } from "components/tooltipParagraph";
import moment from "moment";
import { CONTACT_STATUS } from "utills/constants";
import Select from "components/select";
import { StylesConfig } from "react-select";
import { get } from "lodash";
import Button from "components/button";
import { ClockIcon } from "@heroicons/react/outline";
import { isHaveActionPermission } from "utills/helpers";

interface ContactTableProps {
  data?: IContactItem[];
  pageSize: number;
  currentPage: number;
  _handleChangeStatus: (id: string, status: ContactStatus) => void;
  _handleOpenHistoryModal: (id: string) => void;
}

const colourStyles: StylesConfig<any> = {
  control: (styles) => ({ ...styles, backgroundColor: 'white' }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#E9ECFF" : isFocused ? "#F6F5FE80" : undefined,
      color: get(data, "value", "") === ContactStatus.UNRESOLVED ? "#ED4927" : get(data, "value", "") === ContactStatus.PROCESSING ? "#007AFF" : "#16831C",
      cursor: isDisabled ? 'not-allowed' : 'default',
    };
  },
  singleValue: (styles, { data }) => ({ 
    ...styles,
    color:  get(data, "value", "") === ContactStatus.UNRESOLVED ? "#ED4927" : get(data, "value", "") === ContactStatus.PROCESSING ? "#007AFF" : "#16831C",
  }),
};

export const ContactTable = ({
  data = [],
  pageSize = 10,
  currentPage = 1,
  _handleChangeStatus,
  _handleOpenHistoryModal
}: ContactTableProps) => {
  return (
    <div className="flow-root">
      <div className="relative inline-block w-full align-middle box-border">
        <table className="w-full divide-y divide-gray-300 bg-magnolia-500 rounded-md">
          <thead>
            <tr>
              <th scope="col" className="th py-3.5 pl-4 pr-3 sm:pl-6 lg:pl-8">
                No
              </th>
              <th scope="col" className="th">
                Category vie
              </th>
              <th scope="col" className="th">
                Email/Phone contact
              </th>
              <th scope="col" className="th">
                Feedback time
              </th>
              <th scope="col" className="th">
                Feedback
              </th>
              <th scope="col" className="th w-56 max-w-full">
                Status
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {data.map((item: IContactItem, index: number) => (
              <tr key={index}>
                <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                  {(currentPage - 1) * pageSize + 1 + index}
                </td>
                <td className="td max-w-10 overflow-x-auto">
                  <TooltipParagraph 
                    text={item.support_center_category_name_vi}
                    className="whitespace-pre-wrap max-w-[280px]"
                  />
                </td>
                <td className="td max-w-10 overflow-x-auto" style={{wordWrap: "break-word"}}>
                  <p>{item.email}</p>
                  <p>{item.phone ? `(+${item.phone_area_code}) ${item.phone}` : ""}</p>
                </td>
                <td className="td overflow-x-auto">
                  {item.created_at ? moment(item.created_at).format("DD/MM/YYYY HH:mm:ss") : ""}
                </td>
                <td className="td overflow-x-auto max-w-60">{item.description}</td>
                <td className="td gap-x-2 py-4 pl-3 pr-4 sm:pr-6 lg:pr-8">
                  <div className="max-w-full">
                    <Select
                      options={CONTACT_STATUS}
                      id="contact-status"
                      placeholder="Select Status"
                      className="py-0.5"
                      isDisabled={!isHaveActionPermission("contact", "cs", "edit")}
                      value={CONTACT_STATUS.find((d) => d.value === item.status)}
                      onChange={(selected: {label: string; value: ContactStatus}) => _handleChangeStatus(item.id, selected?.value)}
                      styles={colourStyles}
                    />
                  </div>
                </td>
                <td className="td gap-x-2 py-4 pl-3 pr-4 sm:pr-6 lg:pr-8">
                  <div className="max-w-full float-right">
                    <Button 
                      className="w-8 h-8 bg-magnolia-600 hover:bg-magnolia-600 active:bg-magnolia-600 active:opacity-85"
                      onClick={() => _handleOpenHistoryModal(item.id)}
                    >
                      <ClockIcon className="w-4 h-4 text-brand-500" />
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
